module.exports = __webpack_public_path__ + "static/media/jeep.dba2b302.png";